import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../utils/bonus';
import SpellCashPortionRelease from '../../../SpellCashPortionRelease/SpellCashPortionRelease';
import TicketSetRecord from '../../../TicketSetRecord/TicketSetRecord';

import { TXTCLI_Each_ticket_set_consists_of_th_ELL } from './CashBonus.messages.json';

interface Props {
  bonus: number;
  bonusFormatted: number | JSX.Element;
  formattedAmount: JSX.Element;
  isSingleTicketInSet: boolean;
  isFirst: boolean;
}

const CashBonus: React.FC<Props> = ({
  bonus,
  bonusFormatted,
  formattedAmount,
  isSingleTicketInSet,
  isFirst
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    numOfTickets,
    releasePortion,
    fppReleasePortion,
    ticketSet,
    fppToExercise,
    bonusCurrency
  } = preCashinInfo as PreCashinInfo;

  const isPortionLessThanBonus = fppReleasePortion && releasePortion < bonus;
  const hasZeroTickets = numOfTickets === 0;

  if (hasZeroTickets) {
    return (
      <Translation
        tagName="p"
        {...getBonusMessage(
          isFirst ? Messages.CashFirst : Messages.CashYour,
          !!isPortionLessThanBonus,
          hasZeroTickets
        )}
        values={{
          0: formattedAmount,
          1: bonusFormatted,
          ...(isPortionLessThanBonus
            ? {
                2: <CurrencyAmount value={releasePortion} currency={bonusCurrency} />,
                3: fppReleasePortion
              }
            : {
                2: fppToExercise
              })
        }}
      />
    );
  }

  return (
    <>
      <Translation
        tagName="p"
        {...getBonusMessage(
          isFirst ? Messages.CashFirst : Messages.CashYour,
          isSingleTicketInSet,
          hasZeroTickets
        )}
        values={{ 0: formattedAmount }}
      />
      {isPortionLessThanBonus && !isSingleTicketInSet && (
        <>
          <Translation tagName="p" {...TXTCLI_Each_ticket_set_consists_of_th_ELL} />
          <TicketSetRecord ticketSet={ticketSet} />
        </>
      )}
      <SpellCashPortionRelease bonusFormatted={bonusFormatted} />
    </>
  );
};

export default CashBonus;
